module.exports = __webpack_public_path__ + "img/youtube.d8cae9b1.svg";